import CarouselComponent from "../lib/carousel_component";

export const CarouselControlsConfig = {
    componentTypeKey: 'CarouselControls',
    baseHtmlClass: 'carousel__controls',
    selector: '.carousel__controls',
    prevSelector: '.carousel__control--prev',
    nextSelector: '.carousel__control--next',
    toggleSelector: '.carousel__control--toggle',
};

export class CarouselControls extends CarouselComponent {
    
    static get config() {
        return CarouselControlsConfig;
    }

    constructor(id_or_element, carousel) {
        super(id_or_element, carousel, CarouselControlsConfig);
        
        this.carousel = carousel;
        
        this.prevButton = this.element.querySelector(CarouselControlsConfig.prevSelector);
        this.nextButton = this.element.querySelector(CarouselControlsConfig.nextSelector);
        this.toggleButton = this.element.querySelector(CarouselControlsConfig.toggleSelector);

        this.setupEventListeners();
        this.render();
    }

    setupEventListeners() {
        if (this.prevButton) {
            this.prevButton.addEventListener('click', this.handlePrevClick.bind(this));
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', this.handleNextClick.bind(this));
        }

        if (this.toggleButton) {
            this.toggleButton.addEventListener('click', this.handleToggleClick.bind(this));
        }
    }

    handlePrevClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.carousel.previousSlide();
    }

    handleNextClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.carousel.nextSlide();
    }

    handleToggleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.carousel.toggleAutoplay();
    }

    render() {
        if (this.toggleButton) {
            const isPlaying = this.carousel.isAutoPlaying;
            this.toggleButton.setAttribute('aria-pressed', isPlaying.toString());
            this.toggleButton.setAttribute('aria-label', isPlaying ? 'Pause slideshow' : 'Play slideshow');
            this.toggleButton.textContent = isPlaying ? 'Pause' : 'Play';
        }
    }
}